export default "__VITE_ASSET__CFmoR6BF__"